import type React from "react"
import "./dashboard-card.css"
import CurrencyTooltip from "../../../components/currencytooltip/CurrencyTooltip"
import CustomTooltip from "../../../components/common/CustomTooltip"

interface FooterColumn {
  valueRaw: string | number
  value: string | number
  label: string
}

interface DashboardCardProps {
  icon?: any
  rawValue?: string | number
  mainValue: string | number
  isCurrency?: boolean
  isSubCurrency?: boolean
  mainLabel: string
  footerColumns: FooterColumn[]
  className?: string
}

const DashboardCard: React.FC<DashboardCardProps> = ({ icon, rawValue, mainValue, isCurrency, isSubCurrency, mainLabel, footerColumns, className = "" }) => {
  return (
    <div className={`dashboard-card ${className}`}>
      <div className="dashboard-card-header">
        {icon && <div className="dashboard-card-icon">{icon}</div>}
        <div className="dashboard-card-main">
          <div className="dashboard-card-value">
            {isCurrency ? (
              <CurrencyTooltip content={rawValue} formatted={mainValue}>
                <span>{mainValue}</span>
              </CurrencyTooltip>
            ) : (
              <CustomTooltip content={rawValue} disabled={mainValue === rawValue}>
                <span>{mainValue}</span>
              </CustomTooltip>
            )}
          </div>
          <div className="dashboard-card-label">{mainLabel}</div>
        </div>
      </div>

      {footerColumns.length > 0 && (
        <div className="dashboard-card-footer">
          {footerColumns.map((column, index) => (
            <div key={index} className="dashboard-card-footer-column">
              <div className="dashboard-card-footer-value">
                {isSubCurrency ? (
                  <CurrencyTooltip content={column?.valueRaw} formatted={column?.value}>
                    <span>{column?.value}</span>
                  </CurrencyTooltip>
                ) : (
                  <CustomTooltip content={column?.valueRaw} disabled={column?.value === column?.valueRaw}>
                    <span>{column?.value}</span>
                  </CustomTooltip>
                )}
              </div>
              <div className="dashboard-card-footer-label">{column?.label || ""}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default DashboardCard
